import { render, staticRenderFns } from "./FeedFilters.vue?vue&type=template&id=545b4de8&scoped=true"
import script from "./FeedFilters.vue?vue&type=script&lang=js"
export * from "./FeedFilters.vue?vue&type=script&lang=js"
import style0 from "./FeedFilters.vue?vue&type=style&index=0&id=545b4de8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545b4de8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('545b4de8')) {
      api.createRecord('545b4de8', component.options)
    } else {
      api.reload('545b4de8', component.options)
    }
    module.hot.accept("./FeedFilters.vue?vue&type=template&id=545b4de8&scoped=true", function () {
      api.rerender('545b4de8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/home/FeedFilters.vue"
export default component.exports